module.exports = function(service) {
	'use strict'
	service.factory('navigationService',navigationService);
	navigationService.$inject=['$rootScope','getDataService','refreshtokenService','serverError','offlineError'];
	function navigationService($rootScope, getDataService,refreshtokenService,serverError,offlineError) {
			var navigation = {
		
			getNavigation: function() {
				var getNavigationFunction = function() {
					getDataService.get({param1:'options', param2: "dashboard", param3:"navigation"}).$promise.then(function(dataNavigation){
						$rootScope.navigation = dataNavigation.navigation;
						return $rootScope.navigation
					},function(error) {
						if(!window.navigator.onLine) {
							offlineError('refresh')
							return
						}
						if(error.status ==401) {
							var promise = refreshtokenService.getAccessToken();
				          	promise.then(
				            function(answer) {
				            	if(answer == 200) {
									getNavigationFunction();
				            	}
							},
				            function(error) {
				              // report something
				            },
				            function(progress) {
				             // report progress
				          });
						} else if(error.status ==502) {
							serverError();
						}
					});
				}		
				getNavigationFunction();	
			}
		}
		return navigation	
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/navigationService.js
// module id = 617
// module chunks = 0